export const welcome = "welcome";
export const completeSteps = "completeSteps";
export const chooseLanguage = "chooseLanguage";
export const next = "next";
export const terms = "terms";
export const termsBtn = "termsBtn";
export const estimatedTime = "estimatedTime";
export const progressAutoSave = "progressAutoSave";
